<template>
	<div class="grid-flex-container pa-4">
		<div style="flex-grow: 1">
			<v-form ref="form">
				<v-row>
					<v-col>
						<v-text-field
							v-model="formClient.Name"
							name="name"
							label="Name"
							:rules="nameRules"
							required
					/></v-col>
				</v-row>
				<v-row>
					<v-col>
						<v-text-field
							v-model="formClient.Description"
							name="description"
							label="Description"
							required
						/>
					</v-col> </v-row
				><v-row>
					<v-col>
						<v-text-field
							v-model="formClient.Host"
							name="host"
							label="Client Access URL (ex:  clientname.mydomain.com)"
							:rules="hostRules"
							required
						/>
					</v-col> </v-row
				><v-row>
					<v-col>
						<v-select
							v-model="formClient.LoginMethod"
							:items="loginItems"
							item-text="text"
							item-value="id"
							name="LoginMethod"
							label="LoginMethod"
							:rules="loginRules"
							required
					/></v-col>
				</v-row>

				<v-row no-gutters v-if="formClient.Logo">
					<v-img
						class="my-2"
						v-if="formClient.Logo"
						:src="getClientLogoURL(formClient.Logo)"
						max-height="200"
						max-width="200"
					/>
					<v-btn
						class="action-btn"
						fab
						small
						icon
						elevation="1"
						color="error"
						@click.stop="deleteClientLogo"
					>
						<v-icon small> mdi-delete</v-icon>
					</v-btn>
				</v-row>

				<v-row no-gutters v-else>
					<v-file-input
						v-model="logo"
						counterlabel="File input"
						placeholder="Select Client Logo"
						prepend-icon="mdi-paperclip"
						dense
						accept="image/*"
						show-size
					/>
				</v-row>
			</v-form>

			<v-row class="mt-2" v-if="formClient.Id">
				<v-col
					style="
						background-color: #ffc00030;
						display: flex;
						justify-content: flex-end;
						align-content: space-between;
						margin-top: ;
					"
				>
					<div
						v-if="formClient.DbConnection"
						style="display: flex; align-items: center"
					>
						<p style="font-size: 80%; margin-bottom: 0">
							<b>
								Server Name:
								{{ formClient.DbConnection.SqlServerName }}
								; Database Name:
								{{ formClient.DbConnection.DatabaseName }}
							</b>
						</p>
					</div>
					<div
						v-if="formClient.DbConnection == null"
						style="font-size: 80%; margin-bottom: 0"
					>
						<p>
							<b>There is no DbConnection defined yet</b>
						</p>
					</div>

					<v-spacer />
					<v-btn
						v-if="showDbButton"
						color="primary"
						@click="dbConnectionSetup()"
					>
						<v-icon class="mr-2">mdi-content-save</v-icon>
						DbConnectionSetup
					</v-btn>
				</v-col>
			</v-row>
		</div>
		<div style="flex-grow: 1"></div>
		<v-card-actions style="justify-content: flex-end">
			<v-btn text outlined @click="onCancel"> Cancel </v-btn>
			<v-btn color="primary" @click="onSubmit">
				<v-icon class="mr-2">mdi-content-save</v-icon>
				Submit
			</v-btn>
		</v-card-actions>
		<db-connection
			v-if="showDialog"
			:dbConnection="dbConnection"
			:showDialog="showDialog"
			@save="submitDbConnection"
			@cancel="cancelDbConnection"
		/>
	</div>
</template>
<script>
import { ClientManagementActions } from '../../store/actions';
import { ClientManagementGetters } from '../../store/getters';
import { ClientContextActions } from '../../store/actions';
import { IrisLoginMethod } from '../../enums/irisLoginMethod';
import DbConnection from '@/components/shared/DbConnection.vue';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import { mapGetters } from 'vuex';
import vueAppSubfolder from '../../utils/appSubfolderUtils';
export default {
	name: 'AddEditClientModal',
	props: {},
	components: { DbConnection },
	data() {
		return {
			logo: null,
			id: '',
			showDialog: false,
			loginItems: [
				{ id: IrisLoginMethod.Forms, text: 'Forms' },
				{ id: IrisLoginMethod.Windows, text: 'Windows' },
				{ id: IrisLoginMethod.SingleSignOn, text: 'SingleSignOn' },
			],
			loginRules: [(v) => !!v || 'Login method must be selected'],
			nameRules: [(v) => !!v || 'Name is required'],
			hostRules: [(v) => !!v || 'Client Access URL is required'],
		};
	},
	computed: {
		...mapGetters({
			selectedClient: [ClientManagementGetters.GET_SELECTED_CLIENT],
			dbConnection: [ClientManagementGetters.GET_DBCONNECTION],
		}),
		formClient() {
			return Object.assign({}, this.selectedClient);
		},
		showDbButton() {
			if (this.dbConnection) return false;
			return true;
		},
	},
	destroyed() {
		this.$store.dispatch(ClientManagementActions.CLEAR_SELECTED_CLIENT);
	},
	mounted() {
		if (this.$route.params.id) {
			this.id = this.$route.params.id;
			this.loadData();
		}
	},
	methods: {
		deleteClientLogo() {
			ConfirmDialog({
				message: 'Are you sure you want to delete this logo?',
			}).then((isDelete) => {
				if (!isDelete) return;
				this.$store.dispatch(
					ClientManagementActions.REMOVE_LOGO,
					this.formClient
				);
			});
		},
		getClientLogoURL(image) {
			let path =
				window.location.origin +
				(vueAppSubfolder.get() === '/' ? '' : vueAppSubfolder.get()) +
				'/uploads';
			path = path + image;
			return path;
		},
		fileChange(e) {
			if (e.target.files && e.target.files.length > 0) {
				let file = e.target.files;
				this.files.append('file', file[0], file[0].name);
			}
		},
		loadData() {
			this.$store.dispatch(
				ClientManagementActions.LOAD_DATA_BYCLIENTID,
				this.$route.params.id
			);
		},

		submitDbConnection(item) {
			item.ClientId = this.selectedClient.Id;
			if (item.Id) {
				this.$store
					.dispatch(ClientManagementActions.UPDATE_DBCONNECTION, item)
					.then(() => {
						this.showDialog = false;
						this.loadData();
					});
			} else {
				this.$store
					.dispatch(
						ClientManagementActions.LOAD_DB_BYCLIENTNAME,
						item.DatabaseName
					)
					.then((resp) => {
						if (resp)
							this.$store
								.dispatch(
									ClientManagementActions.INSERT_DBCONNECTION,
									item
								)
								.then(() => {
									return this.$store.dispatch(
										ClientContextActions.RELOAD_CLIENT_CONTEXT
									);
								})
								.then(() => {
									this.showDialog = false;
									this.loadData();
								});
					});
			}
		},
		cancelDbConnection() {
			this.showDialog = false;
		},
		dbConnectionSetup() {
			this.showDialog = true;
		},
		onCancel() {
			this.$emit('cancel');
			this.$router.push({ path: '/clients-management', replace: true });
		},
		onSubmit() {
			if (this.$refs.form.validate()) {
				if (this.formClient.Id) {
					this.$store
						.dispatch(ClientManagementActions.UPDATE, {
							item: this.formClient,
							logo: this.logo,
						})
						.then(() => {
							this.$router.push({
								name: 'ClientsManagementEdit',
								params: { id: this.formClient.Id },
								replace: true,
							});
						});
				} else {
					this.$store
						.dispatch(ClientManagementActions.INSERT, {
							item: this.formClient,
							logo: this.logo,
						})
						.then(() => {
							let id = this.selectedClient.Id;
							this.$router.push({
								name: 'ClientsManagementEdit',
								params: { id: id },
								replace: true,
							});
						});
				}
			}
		},
	},
};
</script>
<style scoped>
#mainContent {
	display: flex;
}
</style>
